// extracted by mini-css-extract-plugin
module.exports = {"selectedCountry":"_3E13p _1R_Wx"};